import { render, staticRenderFns } from "./UnSavedAlertDialog.vue?vue&type=template&id=cfbe1d20&"
import script from "./UnSavedAlertDialog.vue?vue&type=script&lang=js&"
export * from "./UnSavedAlertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports